module.exports = __webpack_public_path__ + "media/images/svg/juice-54ededd92c1cb6f07b993e375f4b2b03.svg";